/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';


var Layout = require('mag-component-layout');


/**
 * Render item function for tv channel list.
 *
 * @param {HTMLElement} $item - $item to render
 * @param {Object} config - config of new data
 */
module.exports = function ( $item, config ) {
    var layout,
        currentNode,
        currentData,
        hardcodeDomValue,
        index,
        layoutConfig;

    if ( $item.ready && true ) {
        for ( index = 0; index < config.items.length; index++ ) {
            currentData = config.items[index];
            if ( typeof currentData.value === 'string' || currentData.value === undefined ) {
                currentNode = $item.layout.$node.childNodes[index];
                currentNode.innerText = currentData.value || '';
                currentNode.className = currentData.className || '';
            } else if ( currentData.htmlInstance ) {
                currentNode = $item.layout.$node.childNodes[index];
                $item.domLinks.$title.innerText = currentData.realValue.name;
                $item.domLinks.$epg.innerText = currentData.realValue.epg || '';
            }
        }
    } else {
        // clear inner content
        while ( $item.firstChild ) {
            $item.removeChild($item.firstChild);
        }

        layoutConfig = {
            focusable: false,
            data: config.items
        };

        if ( config.className ) {
            layoutConfig.className = config.className;
        }

        layout = new Layout(layoutConfig);

        hardcodeDomValue = config.items[1].value;


        // on init list save needed links
        $item.domLinks = {
            $title: hardcodeDomValue.firstChild,
            $epg: hardcodeDomValue.firstChild.nextSibling
        };

        $item.appendChild(layout.$node);
        $item.layout = layout;
        layout.parent = this;
        layout.$parentItem = $item;

        // focus layoutList if click on layout
        layout.addListener('click', function () {
            /*eslint no-invalid-this:0*/
            // add inner property to set that event comes from inner component
            this.parent.emit('click:item', {$item: $item, inner: true});
        });

        if ( config.click ) {
            this.handlers[$item.index] = config.click;
        }
        // item is rendered
        $item.ready = true;
    }
    $item.value = config.value || {};
};
